import React, {useState, useEffect, useContext, lazy, Suspense} from 'react'
import {
    Typography,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Grid,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
//import {myAccountSchema} from '../../utils/constants'
//import {myAccountCapTechSurveySchema} from '../../utils/constants'
import Loader from '../../../components/Loader'
import {GlobalSetting} from '../../../utils/constants'
import {MyAccountContext} from '../../containers/Layout'
// import {MyAccountContext} from '../../containers/Layout'
import _ from 'lodash'

const Provider = lazy(() => import('../../containers/Provider'))
const ProviderTab = lazy(() => import('../../containers/ProviderTab'))
const Location = lazy(() => import('../../containers/Location'))
const EDDetails = lazy(() => import('../../containers/EmergencyDepartment/EDDetails'))
const Demographic = lazy(() => import('../../containers/Demographic'))
const Contact = lazy(() => import('../../containers/Demographic/Contact'))
const TinInformation = lazy(() => import('../../containers/Demographic/TinInformation'))
const Agreements = lazy(() => import('../../containers/Agreements'))
const Payment = lazy(() => import('../../containers/Payment'))
const RegistryInfo = lazy(() => import('../../containers/RegistryInfo'))
const Technical = lazy(() => import('../../containers/Technical'))
const User = lazy(() => import('../../containers/User'))

const components = {
    provider: Provider,
    providertab: ProviderTab,
    location: Location,
    ed: EDDetails,
    demographic: Demographic,
    contact: Contact,
    tininformation: TinInformation,
    agreements: Agreements,
    payment: Payment,
    registryinfo: RegistryInfo,
    technical: Technical,
    user: User,
}

const SectionPanel = props => {
    const sections = props.content
    const [sectionState, setSectionState] = useState([])

    useEffect(() => {
        const sectionsArr = []
        sections.forEach(element => {
            const obj = {name: element.sectionname, isExpanded: true}
            sectionsArr.push(obj)
        })

        setSectionState(sectionsArr)
    }, [])

    const updateSectionState = key => {
        const updatedSectionState = sectionState.map(p => {
            if (p.name === key) p.isExpanded = !p.isExpanded
            return p
        })
        setSectionState([...new Set([...sectionState, ...updatedSectionState])])
    }

    const getSectionState = key => {
        const obj = sectionState.filter(p => p.name === key)
        return obj.length > 0 ? obj[0].isExpanded : true
    }

    return (
        <>
            {sections.map((obj, index) => {
                const ComponentName = components[obj.componentType.toLowerCase()]
                return (
                    <ExpansionPanel
                        key={obj.sectionname}
                        expanded={getSectionState(obj.sectionname)}
                        onChange={() => updateSectionState(obj.sectionname)}
                        className="accordion_master-wrapper"
                        // TransitionProps={{unmountOnExit: true}}
                    >
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1c-content"
                            id="panel1c-header"
                            className="accordion_master-header__wrapper"
                        >
                            <Grid className="accordion_master__header ">
                                {obj.icon && (
                                    <FontAwesomeIcon
                                        icon={['fal', obj.icon]}
                                    ></FontAwesomeIcon>
                                )}
                                <Typography variant="h5" className="accordion_title_h5">
                                    {obj.sectionname}
                                </Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="accordion_master-content__wrapper ">
                            <Grid container className="accordion_master-content__row">
                                <Grid item xs className="accordion_master-content__grid">
                                    <Suspense fallback={<Loader type="page" />}>
                                        <ComponentName {...obj} />
                                    </Suspense>
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )
            })}
        </>
    )
}

const MenuContent = props => {
    const {clientObject, practiceObject, myAccountSchema} = useContext(MyAccountContext)
    const MainComponentName = components[props.componentName.toLowerCase()]
    let menuContent
    const componentName = props.componentName
    menuContent =
        myAccountSchema.myAccountSchema &&
        myAccountSchema.myAccountSchema.filter(
            element => element.componentType.toLowerCase() === componentName.toLowerCase()
        )

    menuContent = Array.isArray(menuContent) && menuContent[0]
    const sections = (menuContent && _.cloneDeep(menuContent.sections)) || []

    // //temporary code for hiding clinician status starts
    // if (
    //     !GlobalSetting.clinicianConfig.status &&
    //     sections[0].componentType.toLowerCase() === 'provider'
    // ) {
    //     const schemaAlteration = JSON.parse(JSON.stringify(sections[0]))
    //     const schemaColumns =
    //         schemaAlteration.mastersectiondetails[0].jsonschema.clinicianColumns
    //     const schemaValue =
    //         schemaAlteration.mastersectiondetails[0].jsonschema.addClinicianForm.fields[3]
    //             .value

    //     const filteredColumns = schemaColumns.filter(c => c.columnLabel !== 'Status')
    //     schemaAlteration.mastersectiondetails[0].jsonschema.clinicianColumns = filteredColumns

    //     const filteredField = schemaValue.filter(d => d.fieldName !== 'Active')
    //     schemaAlteration.mastersectiondetails[0].jsonschema.addClinicianForm.fields[3].value = filteredField

    //     sections[0] = schemaAlteration
    // }
    // //temporary code ends

    if (
        clientObject &&
        clientObject.entitytypeid === 5 &&
        menuContent.componentType.toLowerCase() === 'location'
    ) {
        // CAP Hide TIN on grid column and fields from ADD/Edit popup
        const schemaAlteration = JSON.parse(JSON.stringify(sections[0]))
        const schemaColumns =
            schemaAlteration.mastersectiondetails[0].jsonschema.locationColumns

        const filteredColumns = schemaColumns.filter(
            c => c.columnLabel !== 'Tax Identification Number'
        )
        schemaAlteration.mastersectiondetails[0].jsonschema.locationColumns = filteredColumns

        schemaAlteration.mastersectiondetails[0].jsonschema.addLocationForm.fields.map(
            field => {
                if (typeof field.value === 'object' && field.value.length > 0) {
                    field.value.map(val => {
                        if (val.internalFlag && val.internalFlag === 'ForCAPHide') {
                            //val.fieldName === 'Select Tax Identification Number') {
                            val.isHide = true
                        }
                    })
                } else if (field.internalFlag && field.internalFlag === 'ForCAPHide') {
                    //field.value === 'Tax Identification Number Details') {
                    field.isHidden = true
                }
            }
        )

        sections[0] = schemaAlteration
    }

    let sectionJsx = null
    if (
        menuContent.componentType.toLowerCase() === 'technical' ||
        menuContent.componentType.toLowerCase() === 'provider' ||
        menuContent.componentType.toLowerCase() === 'location' ||
        menuContent.componentType.toLowerCase() === 'ed' ||
        menuContent.componentType.toLowerCase() === 'user'
    ) {
        if (
            menuContent.componentType.toLowerCase() === 'technical' &&
            clientObject.entitytypeid === 5
        ) {
            sectionJsx = (
                <Suspense fallback={<Loader type="page" />}>
                    <MainComponentName
                        {...myAccountSchema.myAccountCapTechSurveySchema[0].sections[0]}
                    />
                </Suspense>
            )
        } else
            sectionJsx = (
                <Suspense fallback={<Loader type="page" />}>
                    <MainComponentName {...sections[0]} />
                </Suspense>
            )
    } else if (!props.isProgram && sections && sections.length > 0)
        sectionJsx = <SectionPanel content={sections} />
    else if (props.isProgram || sections.length === 0) {
        let propsNew =
            sections.length === 0
                ? {isProgram: props.isProgram, ...props}
                : {isProgram: props.isProgram, ...sections[0]}
        sectionJsx = (
            <Suspense fallback={<Loader type="page" />}>
                <MainComponentName {...propsNew} />
            </Suspense>
        )
    }

    return (
        <div className="ma-main-page__wrapper prgrm-hdr__wrpr">
            {(menuContent.menuname || menuContent.icon) && props.setRouter && (
                <Grid container spacing={3} className="program-dtls_header">
                    <Grid item className="program-header__ttl">
                        <Typography
                            className="form-row--heading_h6"
                            variant="h6"
                            gutterBottom
                        >
                            {menuContent.icon && (
                                <FontAwesomeIcon
                                    icon={['fal', menuContent.icon]}
                                    onClick={() =>
                                        props.setRouter(props.backRouter || 'dashboard')
                                    }
                                ></FontAwesomeIcon>
                            )}{' '}
                            &nbsp;
                            {menuContent.menuname}
                        </Typography>
                    </Grid>
                    {menuContent.menuname.toLowerCase() !==
                        'ORGANIZATION DETAILS'.toLowerCase() && (
                        <Grid item xs className="program-header__practice-name__wrapper">
                            <Grid xs className="program-header__practice-name">
                                <div className="practice__name">
                                    {' '}
                                    {practiceObject.practicename}
                                    <span className="practice__id">
                                        ({practiceObject.practiceId})
                                    </span>
                                </div>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}
            {sectionJsx}
        </div>
    )
}

export default MenuContent
